// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import companiesReducer from '../features/companies/companiesSlice';
import packagesReducer from '../features/packages/packagesSlice';
import filtersReducer from '../features/filters/filtersSlice';
import adminReducer from '../features/admin/adminSlice';
import settingsReducer from '../features/settings/settingsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    companies: companiesReducer,
    packages: packagesReducer,
    filters: filtersReducer,
    admin: adminReducer,
    settings: settingsReducer,
  },
  // Activer les devTools uniquement en développement
  devTools: process.env.NODE_ENV !== 'production',
});